// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1W9FK","icon":"SortAdornment_icon__1-XVh","up":"SortAdornment_up__12Yd9","down":"SortAdornment_down__2TC46","active":"SortAdornment_active__1uq-B"};